module.exports = __webpack_public_path__ + "assets/img/capitalist.d8d7e1c9.svg";